import { ShieldCheck } from "@phosphor-icons/react";

/**
 * Insignia visible "Organizador autorizado" para jugadores/profesores
 * con al menos uno de los permisos can_create_retas/tournaments/leagues.
 *
 * Variantes:
 *  - "inline" (default): chip compacto, ideal para nombres / headers.
 *  - "tile": badge más grande con texto explicativo (perfil).
 */
export default function OrganizerBadge({ user, variant = "inline", className = "" }) {
  if (!user) return null;
  const role = user.role;
  // Admin & directivo are organizers by default — their badge looks slightly different
  const isStaff = role === "admin" || role === "directivo";
  const perms = user.permissions || {};
  const granted = [
    perms.can_create_retas,
    perms.can_create_tournaments,
    perms.can_create_leagues,
  ].some(Boolean);
  if (!isStaff && !granted) return null;

  const list = [];
  if (isStaff) {
    list.push("Retas", "Torneos", "Ligas");
  } else {
    if (perms.can_create_retas) list.push("Retas");
    if (perms.can_create_tournaments) list.push("Torneos");
    if (perms.can_create_leagues) list.push("Ligas");
  }
  const label = isStaff ? `${role[0].toUpperCase() + role.slice(1)} · Organizador` : "Organizador autorizado";

  if (variant === "tile") {
    return (
      <div
        data-testid="organizer-badge-tile"
        className={`inline-flex items-start gap-2 rounded-md border border-[#CCFF00]/40 bg-[#CCFF00]/10 px-3 py-2 ${className}`}
      >
        <ShieldCheck size={20} weight="fill" className="text-[#CCFF00] mt-0.5 shrink-0" />
        <div className="leading-tight">
          <p className="text-[10px] tracking-[0.2em] uppercase font-bold text-[#CCFF00]">{label}</p>
          <p className="text-[11px] text-gray-300 mt-0.5">Puede crear · {list.join(" · ")}</p>
        </div>
      </div>
    );
  }

  return (
    <span
      data-testid="organizer-badge-inline"
      title={`${label} — ${list.join(", ")}`}
      className={`inline-flex items-center gap-1 rounded border border-[#CCFF00]/40 bg-[#CCFF00]/10 text-[#CCFF00] px-1.5 py-0.5 text-[9px] uppercase tracking-wider font-bold ${className}`}
    >
      <ShieldCheck size={11} weight="fill" />
      Organizador
    </span>
  );
}
